export const transformLabelToPath = (label: string) => {
  if (typeof label !== 'string' || !label) return '';

  return label
    .trim()
    .toLowerCase()
    .replace(/\s|&amp;|&|\+|\//g, match => (match === ' ' ? '-' : ''))
    .replace(/-+/g, '-');
};
